var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "verified_badge_svg__a",
    x1: 1,
    y1: 0.047,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01cce4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1612"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 12",
    d: "M31 16l-3.327-3.853.464-5.1-4.923-1.128L20.636 1.5 16 3.516 11.364 1.5 8.786 5.905 3.864 7.024l.464 5.11L1 16l3.327 3.853-.464 5.11 4.923 1.132 2.578 4.405L16 28.47l4.636 2.016 2.577-4.405 4.923-1.132-.464-5.1z",
    fill: "#f7f7f8"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 11",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 12",
    d: "M31 16l-3.327-3.853.464-5.1-4.923-1.128L20.636 1.5 16 3.516 11.364 1.5 8.786 5.905 3.864 7.024l.464 5.11L1 16l3.327 3.853-.464 5.11 4.923 1.132 2.578 4.405L16 28.47l4.636 2.016 2.577-4.405 4.923-1.132-.464-5.1zm-17.6 6.518l-5.186-5.261 2.018-2.044L13.4 18.43l7.977-8.106 2.018 2.044z",
    fill: "url(#verified_badge_svg__a)"
  })))));
}
export default SvgVerifiedBadge;